import deleteMeetingMessage from '../actions/deleteMeetingMessage';
import removeCancelledMeetingFromCalendar from '../actions/removeCancelledMeetingFromCalendar';
import { removeCancelledMeetingFromCalendar as removeCancelledMeetingFromCalendarAction } from 'owa-meeting-message-actions';
import { orchestrator } from 'satcheljs';

orchestrator(removeCancelledMeetingFromCalendar, ({ item }) => {
    deleteMeetingMessage(item);
    removeCancelledMeetingFromCalendarAction(item, 'MailListMessage');

    // TODO: VSO - 55914 - When a calendar item is deleted via a Mail message,
    // remove the AssociatedCalendarItemId on the messages in that conversation
});
